import { LoginVariantIcon } from './LoginVariantIcon';

/**
 * author: Austin Andrews
 * id B590AA80-D315-4344-8036-8FBC25C87D2C
 * name login-variant
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/login-variant.svg
 * tags
 */
export const SignInVariantIcon = LoginVariantIcon;
export default SignInVariantIcon